import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from "react-redux";
import { IApplicationState, PhlebotActionCreators, AppActionCreators } from '@nkr/store/index';
import { ICenter, IPhlebotRequest, IListItem, IBaseResponse } from '@nkr/models/index';
import { OrganType } from '@nkr/enums/index';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';
import { GridApi, ColumnApi, GridReadyEvent } from 'ag-grid-community';
import { IOrderListRequestResponse, IOrderLookupResponse } from '@nkr/store/phlebot-service/actions';
import OrderTracker from './order-tracker';
import { IOrderRequest } from '@nkr/models/order-request';
import { toast } from "react-toastify";


interface IProps {
    centerId: number
}

interface IStateProps {
    center: ICenter,
    organType: OrganType
}

interface IDispatchProps {
    hideLoading: () => void,
    showLoading: (message: string) => Promise<void>,
    getRequestList: (startDate: Date, endDate: Date, centerId: number, dateType: number) => Promise<IOrderListRequestResponse>,
    getKitLookupData: (centerId) => Promise<IOrderLookupResponse>
}

type TProps = IStateProps & IDispatchProps & IProps;

interface IState {
    requests: IOrderRequest[],
    kitTypes: IListItem[],
    shipVendors: IListItem[],
    orderStatuses: IListItem[],
    gridApi: GridApi,
    columnApi: ColumnApi
}

class OrderReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        requests: [],
        kitTypes: [],
        shipVendors: [],
        orderStatuses: [],
        gridApi: null,
        columnApi: null
    }

    containerRef: React.RefObject<HTMLDivElement> = React.createRef();

    handleTabSelect = (key: string) => { }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        //this.getRequestsByDateRange(moment().subtract(1, 'month').toDate(), moment().toDate());
    }

    getRequestsByDateRange = (startDate: Date, endDate: Date, dateType: number) => {
        let start = this.props.showLoading('Retrieving Order Tracking Report, one moment please...');

        start.then(() => {
            Promise.all([
                this.props.getRequestList(startDate, endDate, this.props.centerId, dateType),
                this.props.getKitLookupData(this.props.centerId)
            ])
                .then(([listResponse, lookupReponse]) => {
                    if (listResponse.data.success) {
                        let requests = listResponse.data.results;
                        const { kitTypes, shipVendors, orderStatuses } = lookupReponse.data.results;

                        this.setState({
                            requests: requests,
                            kitTypes: kitTypes,
                            shipVendors: shipVendors,
                            orderStatuses: orderStatuses
                        });
                    } else {
                        toast.error("Unable to retrieve Order Tracking Report.  Please contact support.");
                    };

                    this.props.hideLoading();
                })
                .catch(() => {
                    this.props.hideLoading();
                    toast.error("Order Tracking Report request failed.");
                });
        });
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api,
            columnApi: e.columnApi
        });
    }

    updateSearch = (startDate: string, endDate: string, dateType: number) => {
        this.getRequestsByDateRange(moment(startDate).toDate(), moment(endDate).toDate(), dateType);
    }

    handleReorderRequest = (requestId: number) => {

    }

    handleRequestUpdate = (updatedRequest: IOrderRequest) => {
        this.setState({
            requests: this.state.requests.map(x => x.id === updatedRequest.id ? updatedRequest : x)
        });
    }

    updateRequestInViewToSent = (requestId: number) => {

    }

    handleCompletionDeadlineChanged = (entityType: number, entityTypeId: number, completionDeadline: string) => {
        this.setState({
            requests: this.state.requests.map(x =>
                x.entityType === entityType && x.entityTypeId === entityTypeId ? { ...x, completionDeadline } : x
            )
        });
    }

    render = () => {
        return (
            <div style={{ padding: '0px 10px' }} ref={this.containerRef}>
                <OrderTracker
                    isAdmin={this.props.centerId == 0}
                    centerId={this.props.centerId}
                    organType={this.props.organType}
                    list={this.state.requests}
                    kitTypes={this.state.kitTypes}
                    shipVendors={this.state.shipVendors}
                    orderStatuses={this.state.orderStatuses}
                    onGridReady={this.onGridReady}
                    onDateSearch={this.updateSearch}
                    onOrderUpdated={this.handleRequestUpdate}
                    onCompletionDeadlineChanged={this.handleCompletionDeadlineChanged}
                />
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        center: appState.app.center,
        organType: appState.app.site.organType
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { return dispatch(AppActionCreators.hideLoading()); },
        getRequestList: (startDate, endDate, centerId, dateType) => { return dispatch(PhlebotActionCreators.getKitRequestListRange(startDate, endDate, centerId, dateType)); },
        getKitLookupData: (centerId) => { return dispatch(PhlebotActionCreators.getKitLookupData(centerId)); }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(OrderReport);